var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBack15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.7,28.1c-0.3,0.4-0.6,0.7-1,1c-0.4,0.2-0.9,0.4-1.4,0.5c-0.5,0.1-1,0.1-1.6,0.1V32h3.9v10h3.1V26.6h-2.5 C23.1,27.2,23,27.7,22.7,28.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7,41.9c0.7-0.3,1.3-0.7,1.8-1.2c0.5-0.5,0.9-1.1,1.2-1.8c0.3-0.7,0.5-1.4,0.5-2.2c0-0.7-0.1-1.4-0.3-2 c-0.2-0.6-0.5-1.2-0.9-1.7c-0.4-0.5-0.9-0.8-1.5-1.1c-0.6-0.3-1.3-0.4-2-0.4c-0.6,0-1.2,0.1-1.7,0.3c-0.5,0.2-0.9,0.5-1.4,0.9l0,0 l0.6-3.5h6.4v-2.6h-8.6l-1.5,8.5h2.8c0.3-0.4,0.6-0.7,1-0.9c0.4-0.2,0.8-0.3,1.4-0.3c0.4,0,0.8,0.1,1.1,0.2 c0.3,0.1,0.6,0.4,0.8,0.6c0.2,0.3,0.4,0.6,0.5,0.9c0.1,0.4,0.2,0.7,0.2,1.1c0,0.4-0.1,0.8-0.2,1.1c-0.1,0.4-0.3,0.7-0.5,0.9 c-0.2,0.3-0.5,0.5-0.8,0.7c-0.3,0.2-0.7,0.3-1.1,0.3c-0.7,0-1.3-0.2-1.7-0.6c-0.5-0.4-0.7-1-0.8-1.7h-3.1c0,0.8,0.2,1.5,0.5,2.1 c0.3,0.6,0.7,1.1,1.3,1.5c0.5,0.4,1.1,0.7,1.8,0.9c0.7,0.2,1.4,0.3,2.2,0.3C36.3,42.3,37,42.2,37.7,41.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7,15.5H24.3l1.5-1.2c0.8-0.6,0.9-1.8,0.3-2.6c-0.6-0.8-1.8-0.9-2.6-0.3L16,17.3l7.5,5.9c0.3,0.3,0.7,0.4,1.1,0.4 c0.5,0,1.1-0.2,1.4-0.7c0.6-0.8,0.5-2-0.3-2.6l-1.5-1.1h11.4c8.1,0,14.6,6.6,14.6,14.6c0,8.1-6.6,14.6-14.6,14.6 c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.8C45.8,52,54,43.8,54,33.7C54,23.6,45.8,15.5,35.7,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,0C14.3,0,0,14.3,0,32s14.3,32,32,32s32-14.3,32-32S49.7,0,32,0z M32,60C16.6,60,4,47.4,4,32S16.6,4,32,4 c15.4,0,28,12.6,28,28S47.4,60,32,60z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBack15);
export default __webpack_public_path__ + "static/media/ic_back_15.d786f3a71068a49a450cbadc0b2bd836.svg";
export { ForwardRef as ReactComponent };